import { MuiIcon } from "./dekox-icons-types";
import { SvgIconProps } from "@mui/material";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { ForwardedRef, forwardRef } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TuneIcon from "@mui/icons-material/Tune";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import DesignServicesSharpIcon from "@mui/icons-material/DesignServicesSharp";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AddIcon from "@mui/icons-material/Add";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import NumbersIcon from "@mui/icons-material/Numbers";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintIcon from "@mui/icons-material/Print";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InventoryIcon from "@mui/icons-material/Inventory";
import HandymanOutlined from "@mui/icons-material/HandymanOutlined";
import ContactsIcon from "@mui/icons-material/Contacts";
import CallIcon from "@mui/icons-material/Call";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import HelpOutline from "@mui/icons-material/HelpOutline";
import Apartment from "@mui/icons-material/Apartment";
import CallOutlined from "@mui/icons-material/CallOutlined";
import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import PhotoIcon from "@mui/icons-material/Photo";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CheckIcon from "@mui/icons-material/Check";
import LoginIcon from "@mui/icons-material/Login";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LinkIcon from "@mui/icons-material/Link";
import AbcOutlinedIcon from "@mui/icons-material/AbcOutlined";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { Invoice } from "./custom-deko-x-icons";

type Props = SvgIconProps & { icon: MuiIcon };

const DekoxIconBase = (props: Props, ref: ForwardedRef<SVGSVGElement>) => {
  const { icon, ...rest } = props;

  switch (icon) {
    case "arrow-down":
      return <KeyboardArrowDownIcon {...rest} ref={ref} />;
    case "arrow-up":
      return <KeyboardArrowUpIcon {...rest} ref={ref} />;
    case "arrowDropDown":
      return <ArrowDropDownIcon {...rest} ref={ref} />;
    case "arrow-right":
      return <NavigateNextOutlinedIcon {...rest} ref={ref} />;
    case "arrow-left":
      return <ChevronLeftIcon {...rest} ref={ref} />;
    case "arrow-back":
      return <ArrowBackIcon {...rest} ref={ref} />;
    case "filter":
      return <TuneIcon {...rest} ref={ref} />;
    case "search":
      return <SearchIcon {...rest} ref={ref} />;
    case "expand":
      return <ExpandMoreOutlinedIcon {...rest} ref={ref} />;
    case "close":
      return <CloseIcon {...rest} ref={ref} />;
    case "edit":
      return <EditOutlinedIcon {...rest} ref={ref} />;
    case "reload":
      return <RefreshIcon {...rest} ref={ref} />;
    case "googleTranslate":
      return <GTranslateIcon {...rest} ref={ref} />;
    case "units":
      return <DesignServicesSharpIcon {...rest} {...ref} />;
    case "calendar":
      return <CalendarMonthOutlinedIcon {...rest} {...ref} />;
    case "add":
      return <AddIcon {...rest} {...ref} />;
    case "contactPhone":
      return <ContactPhoneIcon {...rest} {...ref} />;
    case "permContactCalendar":
      return <PermContactCalendarIcon {...rest} {...ref} />;
    case "person":
      return <PersonOutlineOutlinedIcon {...rest} {...ref} />;
    case "category":
      return <CategoryOutlinedIcon {...rest} {...ref} />;
    case "numbers":
      return <NumbersIcon {...rest} {...ref} />;
    case "download":
      return <DownloadOutlinedIcon {...rest} ref={ref} />;
    case "print":
      return <PrintIcon {...rest} ref={ref} />;
    case "moreVertical":
      return <MoreVertIcon {...rest} ref={ref} />;
    case "info":
      return <InfoOutlinedIcon {...rest} ref={ref} />;
    case "inventory":
      return <InventoryIcon {...rest} ref={ref} />;
    case "handyman":
      return <HandymanOutlined {...rest} ref={ref} />;
    case "contacts":
      return <ContactsIcon {...rest} ref={ref} />;
    case "call":
      return <CallIcon {...rest} ref={ref} />;
    case "mail":
      return <EmailOutlinedIcon {...rest} ref={ref} />;
    case "account":
      return <AccountCircleOutlinedIcon {...rest} ref={ref} />;
    case "delete":
      return <DeleteOutlineOutlinedIcon {...rest} ref={ref} />;
    case "invoice":
      return <Invoice {...rest} ref={ref} />;
    case "help":
      return <HelpOutline {...rest} ref={ref} />;
    case "apartment":
      return <Apartment {...rest} ref={ref} />;
    case "doubleArrowRight":
      return <KeyboardDoubleArrowRight {...rest} ref={ref} />;
    case "doubleArrowleft":
      return <KeyboardDoubleArrowLeft {...rest} ref={ref} />;
    case "localOffer":
      return <LocalOfferOutlined {...rest} ref={ref} />;
    case "callOutline":
      return <CallOutlined {...rest} ref={ref} />;
    case "photo":
      return <PhotoIcon {...rest} ref={ref} />;
    case "supportAgent":
      return <SupportAgentIcon {...rest} ref={ref} />;
    case "account":
      return <AccountCircleIcon {...rest} ref={ref} />;
    case "check":
      return <CheckIcon {...rest} ref={ref} />;
    case "login":
      return <LoginIcon {...rest} ref={ref} />;
    case "checkCircle":
      return <CheckCircleOutlineIcon {...rest} ref={ref} />;
    case "removeRedEye":
      return <RemoveRedEyeOutlinedIcon {...rest} ref={ref} />;
    case "visibilityOff":
      return <VisibilityOffOutlinedIcon {...rest} ref={ref} />;
    case "imageOutlined":
      return <ImageOutlinedIcon {...rest} ref={ref} />;
    case "descriptionOutlined":
      return <DescriptionOutlinedIcon {...rest} ref={ref} />;
    case "link":
      return <LinkIcon {...rest} ref={ref} />;
    case "abcOutlined":
      return <AbcOutlinedIcon {...rest} ref={ref} />;
    case "fullScreen":
      return <FullscreenIcon {...rest} ref={ref} />;
    case "fullScreenExit":
      return <FullscreenExitIcon {...rest} ref={ref} />;
    case "copy":
      return <ContentCopyIcon {...rest} ref={ref} />;

    default:
      const assertNever: never = icon;
      return assertNever;
  }
};

export const DekoxIcon = forwardRef(DekoxIconBase);
